import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@env/environment';
import { City, Country } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  constructor(@Inject(HttpClient) private readonly http: HttpClient) {}

  getCities(stateId: string) {
    const params = new HttpParams().set('stateId', stateId);
    return this.http.get<{ message: string; data: City[] }>(`${environment.API_URI}/cities`, {
      params,
    });
  }
}
